<div
    *ngIf="employeeDateTime"
    class="row"
>
    <div class="col-lg-6 mb-3">
        <div class="card h-100 shadow">
            <app-help name="attendance.detail.info"></app-help>
            <div class="card-header card-header--padding">
                <div class="row">
                    <div class="col-6 col-sm-6 col-md-7">
                        <p class="modal-title font-16 text-dark pt-2 pb-2">
                            <span>{{ 'menu.employees_datetimes' | translate }}</span>
                        </p>
                    </div>

                    <div class="col-6 col-sm-6 col-md-5 text-right align-self-center">
                        <app-protect-unprotect-datetimes (stateChanged)="getDateTime()" [employeeDatetimeId]="employeeDateTime.employee_datetime_ID" [from]="from" [state]="!employeeDateTime.is_protected" [to]="to"></app-protect-unprotect-datetimes>
                        <button
                            (click)="recalculateDatetimes()"
                            [disabled]="employeeDateTime.is_protected"
                            class="btn btn-light btn-icon mx-2"
                            title="{{ 'employees_datetimes.recalculate_attendance' | translate }}"
                        >
                            <i class="mdi mdi-timer-refresh-outline mdi-24px text-muted"></i>
                        </button>
                        <button
                            (click)="openDatetimeEditModal()"
                            [disabled]="employeeDateTime.is_protected"
                            [updateButton]="'employees_datetimes.action_edit' | translate"
                        ></button>
                    </div>
                </div>
            </div>

            <div class="card-body px-4">
                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees.type_COMMON' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <app-employee-box-avatar [employee]="employeeDateTime.employee"></app-employee-box-avatar>
                    </div>
                </div>

                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.type' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <span>{{ employeeDateTime.type.name }}</span>
                    </div>
                </div>

                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.state' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <span class="text-{{ employeeDateTime.current_state_class }}">
                          <span>{{ employeeDateTime.current_state_name }}</span>
                        </span>
                    </div>
                </div>

                <div *ngIf="authService.loggedUser?.attendance_projects?.active" class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.project' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <span>{{ employeeDateTime.employee_datetime_project_name }}</span>
                    </div>
                </div>

                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.from_to' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2 text-truncate">
                        <span [innerHTML]="employeeDateTime.from_to_label"></span>
                    </div>
                </div>

                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.hours_duration' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <span>{{ employeeDateTime?.hours_duration }} {{ 'employees_datetimes.hours' | translate }}</span>
                    </div>
                </div>

                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.action_set_on_shift_start_end' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <span *ngIf="employeeDateTime.set_on_shift">{{ 'global.YES' | translate }}</span>
                        <span *ngIf="!employeeDateTime.set_on_shift">{{ 'global.NO' | translate }}</span>
                    </div>
                </div>

                <div class="row border-bottom">
                    <div class="col-12 col-sm-12 col-md-5 py-1 py-md-2">
                        <span class="text-dark">{{ 'employees_datetimes.waiting_to_approve_from' | translate }}</span>
                    </div>

                    <div class="col-12 col-sm-9 col-md-6 py-1 py-md-2">
                        <span>{{ employeeDateTime.owner_fullname }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-6 mb-3">
        <div
            *ngIf="employeeDateTime.permissions.can_set_state"
            class="row"
        >
            <div class="col-12 mb-3">
                <div class="card h-100 justify-content-center shadow">
                    <app-help name="attendance.detail.action.approve"></app-help>
                    <div class="card-header border-bottom-0 py-3">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-7">
                                <p class="modal-title font-16 text-dark pt-2 pb-2">
                                    <span>{{ 'employees_datetimes.action_approve' | translate }}</span>
                                </p>
                            </div>

                            <div class="col-6 col-sm-6 col-md-5 text-right align-self-center">
                                <button
                                    (click)="approveDatetime()"
                                    [checkButton]="'employees_datetimes.action_approve' | translate"
                                    [disabled]="employeeDateTime?.state === 'APPROVED' || employeeDateTime.is_protected"
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 mb-3">
                <div class="card h-100 justify-content-center shadow">
                    <app-help name="attendance.detail.action.deny"></app-help>
                    <div class="card-header border-bottom-0 py-3">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-7">
                                <p class="modal-title font-16 text-dark pt-2 pb-2">
                                    <span>{{ 'employees_datetimes.action_deny' | translate }}</span>
                                </p>
                            </div>

                            <div class="col-6 col-sm-6 col-md-5 text-right align-self-center">
                                <button
                                    (click)="declineDatetime()"
                                    [denyButton]="'employees_datetimes.action_deny' | translate"
                                    [disabled]="employeeDateTime?.state === 'DENIED' || employeeDateTime.is_protected"
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card h-100 justify-content-center shadow">
                    <app-help name="attendance.detail.history"></app-help>
                    <div class="card-header px-4">
                        <p class="modal-title font-16 text-dark pt-2 pb-2">
                            <span>{{ 'employees_datetimes.states_history' | translate }}</span>
                        </p>
                    </div>

                    <div class="card-body border-bottom-0 py-3">
                        <small
                            *ngFor="let stateHistoryItem of employeeDateTime.states_history"
                            class="pb-1 my-auto"
                        >
                            <span>{{ stateHistoryItem?.created_at_formatted }}&nbsp;→&nbsp;</span>
                            <span class="text-dark">{{ stateHistoryItem?.author_fullname }}</span>
                            <span> {{ 'employees_datetimes.person_changed_state_to' | translate }}:&nbsp;</span>
                            <span class="text-{{ stateHistoryItem.state_class }}">
                <i class="{{ stateHistoryItem.state_icon }}"></i>
                <span>&nbsp;{{ stateHistoryItem?.state_name }}</span>
              </span>
                            <br>
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="employeeDateTime; else loadingTemplate">
    <div class="row">
        <div class="col-12">
            <div class="card shadow">
                <app-help name="attendance.detail.report"></app-help>
                <div class="card-header card-header--padding">
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-7">
                            <p class="modal-title font-16 text-dark pt-2 pb-2">
                                <span>{{ 'employees_datetimes.report' | translate }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="card-body px-4">
                    <ng-container *ngIf="employeeDateTime.report; else noDataTemplate">
                        <p
                            *ngIf="employeeDateTime?.report as report; else noDataTemplate"
                            [innerHtml]="report | safeHtml"
                        ></p>
                    </ng-container>

                    <ng-template #noDataTemplate>
                        <div class="text-center text-muted">{{ 'global.empty_widget_error' | translate }}</div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="employeeDateTime; else loadingTemplate">
    <div class="row">
        <div class="col-12">
            <div class="card shadow">
                <app-help name="attendance.detail.report"></app-help>
                <div class="card-header card-header--padding">
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-7">
                            <p class="modal-title font-16 text-dark pt-2 pb-2">
                                <span>{{ 'global.attachments' | translate }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="card-body px-4">
                    <ng-container>
                        <app-upload
                            (success)="fetchFiles()"
                            [fileName]="employeeDateTime.employee_datetime_ID"
                            [modelName]="'employee_datetime_ID'"
                            [modelValue]="employeeDateTime.employee_datetime_ID"
                            [secondaryModelValue]="null"
                        ></app-upload>

                        <app-files-table
                            (refetch)="fetchFiles()"
                            *ngIf="files$"
                            [allowDelete]="true"
                            [files$]="files$"
                            [objectType]="'EMPLOYEE_REVIEW'"
                            [object]="employeeDateTime"
                        ></app-files-table>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #loadingTemplate>
    <app-row-loader></app-row-loader>
</ng-template>

<div class="row">
    <div class="col-12">
        <app-employee-attendance-parts
            (refetchDateTime)="getDateTime()"
            *ngIf="employeeDateTime"
            [employeeDateTime]="employeeDateTime"
            [employeeID]="employeeID"
        ></app-employee-attendance-parts>
    </div>
</div>
